import { ReactNode } from 'react';
import { Box, BoxProps } from '@mui/material';
import { responsiveDataGridSx } from './gridResponsive';

interface ResponsiveGridContainerProps extends BoxProps {
  children: ReactNode;
  minHeight?: number | { xs?: number; sm?: number; md?: number };
}

export default function ResponsiveGridContainer({
  children,
  minHeight = { xs: 360, sm: 420 },
  sx,
  ...props
}: ResponsiveGridContainerProps) {
  return (
    <Box sx={{ ...responsiveDataGridSx, minHeight, ...sx }} {...props}>
      {children}
    </Box>
  );
}
